import './newsletter.scss';

/**
 * version    1.0
 * class      <type> (Newsletter)
 * classdesc  Component that manage Newsletter Banner
 */
export class Newsletter {}
